export default {
    /**
     * Sets Angular Controller bindings
     *
     * Usage:
     * const setCtrlParam = AuthComponentUtils.setCtrlParam($ctrl, $scope);
     * setCtrlParam('isRequestInProgress', true);
     *
     * @param {Object} $ctrl
     * @param {Object} $scope
     *
     * @returns {Function}
     */
    setCtrlParam: function setCtrlParam($ctrl, $scope) {
        /**
         * @param {String} paramName
         * @param {*} value
         */
        return function (paramName, value) {
            $scope.$applyAsync(function () {
                $ctrl[paramName] = value;
            });
        };
    }
};


//////////////////
// WEBPACK FOOTER
// ./common/js/src/edge/api/gw-portals-auth-angular/components/common/AuthComponentUtils.js
// module id = 64
// module chunks = 0